<template>
  <div class="scroll-to-top-button" @click="scrollToTop">
    <UiLabel
      :text="$t('products.filters.scrollToTopButton')"
      :icons="LABEL_ICON"
    />
  </div>
</template>

<script lang="ts" setup>
import UiLabel from '@sephora-asia/ui-label'

const LABEL_ICON = {
  left: {
    name: 'caret',
  },
}

function scrollToTop() {
  const productFilterWebEl = document.getElementById('product-filter-web')
  productFilterWebEl?.scrollIntoView({ behavior: 'smooth' })
}
</script>

<style lang="scss" scoped>
.scroll-to-top-button {
  align-self: center;
  :deep(.label-container) {
    .text-container {
      @extend .body-m;
    }
    svg {
      width: 16px;
      height: 16px;
      transform: rotate(180deg);
    }
    :hover {
      cursor: pointer;
    }
  }
}
</style>
